import Storage from './StorageManager';

const fetchPersistentSession = () => Storage.getLocalStorage('PERSISTENT_SESSION') || {};

const createPersistentSession = data => {
  let persistedData = fetchPersistentSession() || {};
  const persistentSession = Storage.getCookie('WC_PERSISTENT');
  persistedData = {
    ...persistedData,
    ...data,
    persistentSession,
  };
  Storage.setLocalStorage('PERSISTENT_SESSION', persistedData);
  return true;
};

const deletePersistentSession = () => {
  Storage.removeLocalStorage('PERSISTENT_SESSION');
  return true;
};

export { createPersistentSession, fetchPersistentSession, deletePersistentSession };
